export class Learner{
    learnerId: number;
    username: string;
    firstName: string;
    lastName: string;
    email: string;
    customerId: number;
}